import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import PropertyMaintenance from "./pages/PropertyMaintenance";
import GardenMaintenance from "./pages/GardenMaintenance";
import Clearance from "./pages/Clearance";
import Seasonal from "./pages/Seasonal";
import Landlords from "./pages/Landlords";
import Sourcing from "./pages/Sourcing";
import Story from "./pages/Story";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/property-maintenance" element={<PropertyMaintenance />} />
            <Route path="/garden-maintenance" element={<GardenMaintenance />} />
            <Route path="/clearance" element={<Clearance />} />
            <Route path="/seasonal" element={<Seasonal />} />
            <Route path="/landlords" element={<Landlords />} />
            <Route path="/sourcing" element={<Sourcing />} />
            <Route path="/story" element={<Story />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
        <Toaster position="bottom-right" theme="light" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
